import i18next, { type i18n as I18n } from 'i18next';
import en from './en.json';
import tr from './tr.json';

export const resources = { tr: { translation: tr }, en: { translation: en } } as const;
export type Language = keyof typeof resources;
export const LANGUAGES: Language[] = ['tr', 'en'];
export { tr as trMessages, en as enMessages };

/** Creates an isolated i18next instance (Turkish first, English fallback). */
export function createI18n(lng: Language = 'tr'): I18n {
  const instance = i18next.createInstance();
  void instance.init({
    resources,
    lng,
    fallbackLng: 'en',
    supportedLngs: LANGUAGES,
    interpolation: { escapeValue: false },
    returnNull: false,
    initAsync: false,
  });
  return instance;
}

/** Flattens nested message objects into dotted keys (used by the CI key-diff script). */
export function flattenKeys(obj: Record<string, unknown>, prefix = ''): string[] {
  return Object.entries(obj).flatMap(([k, v]) => {
    const key = prefix ? `${prefix}.${k}` : k;
    return v && typeof v === 'object' && !Array.isArray(v) ? flattenKeys(v as Record<string, unknown>, key) : [key];
  });
}
